// CLIC58 - Mock Data

export const companyInfo = {
  name: "CLIC58",
  tagline: "À vos côtés depuis 2019",
  phone: "03.86.28.33.19",
  email: "contact@clic58.fr",
  address: "6 rue des Tépins, 58800 CORBIGNY",
  description: "Votre boutique informatique de proximité à Corbigny. Vente, réparation et accompagnement personnalisé pour tous vos équipements numériques.",
  zones: ["Corbigny", "Clamecy", "Tannay", "Brinon sur Beuvron", "Varzy", "Lormes"],
  vacationNotice: "VACANCES DE NOËL DU MERCREDI 17 DÉCEMBRE 2025 AU LUNDI 05 JANVIER 2026 INCLUS",
  logoUrl: "https://customer-assets.emergentagent.com/job_clic58-refresh/artifacts/r19af4hc_logo-clic%20%281%29.svg",
  googleMapsUrl: "https://maps.app.goo.gl/AcNPrwrz5MVqnkTY6"
};

export const openingHours = [
  { day: "Lundi", hours: "Fermé", isClosed: true },
  { day: "Mardi", hours: "9h30 - 12h00 / 14h30 - 18h00", isClosed: false },
  { day: "Mercredi", hours: "9h30 - 12h00", isClosed: false },
  { day: "Jeudi", hours: "9h30 - 12h00 / 14h30 - 18h00", isClosed: false },
  { day: "Vendredi", hours: "9h30 - 12h00 / 14h30 - 18h00", isClosed: false },
  { day: "Samedi", hours: "9h30 - 12h00", isClosed: false },
  { day: "Dimanche", hours: "Fermé", isClosed: true }
];

export const stats = [
  { value: "6+", label: "Années d'expérience" },
  { value: "2000+", label: "Clients satisfaits" },
  { value: "100%", label: "Assistance gratuite" },
  { value: "SAV", label: "À vie sur nos produits" }
];

export const products = [
  {
    id: 1,
    title: "Ordinateurs",
    description: "PC portables et fixes, neufs et reconditionnés. Nous vous conseillons selon vos besoins et votre budget.",
    icon: "Monitor",
    highlights: ["Neufs & reconditionnés", "Toutes marques", "Conseil personnalisé"]
  },
  {
    id: 2,
    title: "Smartphones",
    description: "Large gamme de téléphones avec transfert de données inclus et accompagnement gratuit pour la prise en main.",
    icon: "Smartphone",
    highlights: ["Transfert de données inclus", "Prise en main guidée", "Conseils gratuits à vie"]
  },
  {
    id: 3,
    title: "Tablettes",
    description: "Tablettes pour tous les usages : travail, loisirs, seniors. Configuration et assistance comprises.",
    icon: "Tablet",
    highlights: ["Configuration incluse", "Formation utilisation", "Suivi personnalisé"]
  },
  {
    id: 4,
    title: "Vidéosurveillance",
    description: "Caméras intérieures et extérieures pour sécuriser votre domicile ou commerce. Installation possible.",
    icon: "Camera",
    highlights: ["Intérieur & extérieur", "Installation proposée", "Conseil sécurité"]
  }
];

export const services = [
  {
    id: 1,
    title: "Réparation PC",
    description: "Votre ordinateur est lent, bloqué ou ne démarre plus ? Nous diagnostiquons et réparons tous types de pannes sur PC portables et fixes.",
    icon: "Wrench",
    features: ["Diagnostic complet", "Réparation matérielle", "Nettoyage virus/malwares", "Récupération de données"],
    note: "Réparation ordinateurs uniquement (pas tablettes ni téléphones)"
  },
  {
    id: 2,
    title: "Installation à domicile",
    description: "Nous livrons et installons votre nouvel ordinateur directement chez vous. Configuration complète, connexion internet, imprimante...",
    icon: "Home",
    features: ["Livraison à domicile", "Configuration complète", "Connexion périphériques", "Formation sur place"]
  },
  {
    id: 3,
    title: "Assistance gratuite à vie",
    description: "Pour tout ordinateur acheté chez nous : assistance à distance gratuite via Anydesk jusqu'à la fin de vie de votre machine. Un problème ? On vous aide !",
    icon: "Headphones",
    features: ["Via Anydesk", "Illimitée et gratuite", "Réponse rapide", "Sur tous nos PC vendus"],
    highlight: true
  },
  {
    id: 4,
    title: "Transfert de données",
    description: "Vous changez de smartphone ? Nous transférons toutes vos données, contacts, photos de votre ancien appareil vers le nouveau.",
    icon: "RefreshCw",
    features: ["Contacts & photos", "Applications", "Messages", "Rapide et sécurisé"]
  },
  {
    id: 5,
    title: "Conseils gratuits",
    description: "Vous avez acheté chez nous et vous êtes perdu ? Revenez nous voir sans frais ! On prend le temps de vous expliquer et de vous guider.",
    icon: "MessageCircle",
    features: ["Sans rendez-vous", "Sans limite de temps", "Pour nos clients", "En boutique"],
    highlight: true
  },
  {
    id: 6,
    title: "Maintenance",
    description: "Entretien préventif de votre matériel pour prolonger sa durée de vie : nettoyage, mises à jour, optimisation.",
    icon: "Settings",
    features: ["Nettoyage physique", "Mises à jour système", "Optimisation", "Sauvegarde données"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Aurélie B.",
    text: "Rapide, efficace, ne pousse pas à la dépense. CLIC58 m'a été conseillé et je recommande à mon tour ! Merci Yohan et à très bientôt.",
    rating: 5
  },
  {
    id: 2,
    name: "Luc G.",
    text: "Un grand merci, une grande aide, indispensable. Merci d'avoir sauvé la vie de mon ordinateur / mes données ! Et également merci de la formation rapide afin de ne pas réitérer mes erreurs !",
    rating: 5
  },
  {
    id: 3,
    name: "Muriel J.",
    text: "Un grand merci à CLIC58 pour avoir réactivé l'iPhone de ma fille ! Votre ordi est en panne ou rame, votre mobile est bloqué, dépannage assuré en un temps record pour une somme dérisoire !",
    rating: 5
  }
];

export const faqs = [
  {
    question: "Réparez-vous les téléphones et tablettes ?",
    answer: "Nous réparons uniquement les ordinateurs (portables et fixes). Pour les smartphones et tablettes, nous proposons la vente, le transfert de données et l'accompagnement, mais pas la réparation matérielle."
  },
  {
    question: "L'assistance Anydesk est-elle vraiment gratuite à vie ?",
    answer: "Oui ! Pour tout ordinateur acheté chez CLIC58, vous bénéficiez d'une assistance à distance gratuite et illimitée via Anydesk, jusqu'à la fin de vie de votre machine. C'est notre engagement qualité."
  },
  {
    question: "Puis-je revenir en boutique si j'ai des questions ?",
    answer: "Absolument ! Si vous avez acheté chez nous, vous pouvez revenir autant de fois que nécessaire pour des conseils ou de l'aide. C'est gratuit et sans rendez-vous."
  },
  {
    question: "Proposez-vous l'installation à domicile ?",
    answer: "Oui, nous livrons et installons votre ordinateur directement chez vous sur Corbigny et les environs. Configuration complète, connexion internet, imprimante... tout est inclus !"
  },
  {
    question: "Vendez-vous des caméras de surveillance ?",
    answer: "Oui, nous proposons des caméras de vidéosurveillance pour l'intérieur et l'extérieur. Nous pouvons vous conseiller sur le système adapté à vos besoins et proposer l'installation."
  },
  {
    question: "Comment se passe le transfert de données pour un nouveau téléphone ?",
    answer: "Apportez votre ancien et votre nouveau téléphone en boutique. Nous transférons vos contacts, photos, applications et messages. C'est rapide et sécurisé !"
  }
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_clic58-refresh/artifacts/goazradg_487227629_1199037285560171_7223701043835928656_n.jpg",
  consultation: "https://images.unsplash.com/photo-1664382951070-70a6e4ef8ed0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxJVCUyMHN1cHBvcnR8ZW58MHx8fHwxNzY5MDcxMzA4fDA&ixlib=rb-4.1.0&q=85",
  network: "https://images.pexels.com/photos/442150/pexels-photo-442150.jpeg",
  repair: "https://images.unsplash.com/photo-1604754742629-3e5728249d73?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjb21wdXRlciUyMHJlcGFpcnxlbnwwfHx8fDE3NjkwNzEzMTJ8MA&ixlib=rb-4.1.0&q=85",
  laptop: "https://images.unsplash.com/photo-1620368523635-df9d83338fc1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxjb21wdXRlciUyMHJlcGFpcnxlbnwwfHx8fDE3NjkwNzEzMTJ8MA&ixlib=rb-4.1.0&q=85",
  maintenance: "https://images.pexels.com/photos/7639355/pexels-photo-7639355.jpeg",
  store: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  // Images pour chaque service
  serviceRepair: "https://images.pexels.com/photos/7639355/pexels-photo-7639355.jpeg",
  serviceInstallation: "https://images.pexels.com/photos/442150/pexels-photo-442150.jpeg",
  serviceSupport: "https://images.pexels.com/photos/7195319/pexels-photo-7195319.jpeg",
  serviceTransfer: "https://images.pexels.com/photos/4705618/pexels-photo-4705618.jpeg",
  serviceAdvice: "https://images.unsplash.com/photo-1664382951070-70a6e4ef8ed0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxJVCUyMHN1cHBvcnR8ZW58MHx8fHwxNzY5MDc4OTU3fDA&ixlib=rb-4.1.0&q=85",
  serviceMaintenance: "https://images.unsplash.com/photo-1618171889969-0feeb769fe78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxJVCUyMHN1cHBvcnR8ZW58MHx8fHwxNzY5MDc4OTU3fDA&ixlib=rb-4.1.0&q=85"
};
